import React from 'react';
import NavigationLinks from './NavigationLinks';
import '../../assets/styles/Sidebar.css';

const Sidebar = ({ isOpen, toggleSidebar, stayOpen, toggleStayOpen }) => {
  return (
    <div className={`sidebar ${isOpen ? 'active' : ''}`}>
      <div className="sidebar-header">
        <button className="sidebar-toggle-button" onClick={toggleSidebar}>
          {isOpen ? 'Close' : 'Open'}
        </button>
        <label className="stay-open-label">
          <input type="checkbox" checked={stayOpen} onChange={toggleStayOpen} />
          Stay Open
        </label>
      </div>
      <NavigationLinks onLinkClick={toggleSidebar} />
    </div>
  );
};

export default Sidebar;
